<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false" >
      <HeaderStorage/>
      <div class="grid_custom mt-6 pl-3">
        <v-card class="list_menu_content">
          <router-link to="/stock/storage/mainstorage" class="menu_card_content d-flex flex-column justify-center align-center" >
            <div class="img_menu_content">
              <img src="@/assets/packages.png">
            </div>
            <div class="title_menu_content">
              คลัง
            </div>
          </router-link>
        </v-card>
        <v-card class="list_menu_content">
          <router-link to="/warehousereport" class="menu_card_content d-flex flex-column justify-center align-center">
            <div class="img_menu_content">
              <img src="@/assets/warehouse.png">
            </div>
            <div class="title_menu_content">
              รายงานคลังสินค้า
            </div>
          </router-link>
        </v-card>
        <v-card class="list_menu_content">
          <router-link to="/stock/document/governmentreceipt" class="menu_card_content d-flex flex-column justify-center align-center">
            <div class="img_menu_content">
              <img src="@/assets/document.png">
            </div>
            <div class="title_menu_content">
              ใบส่งคืนสินค้า
            </div>
          </router-link>
        </v-card>
        <v-card class="list_menu_content" v-if="$store.state.status == 1 || $store.state.userDetail.manage_product_list == 1 || $store.state.userDetail.manage_product_create == 1 || $store.state.userDetail.manage_product_edit == 1 || $store.state.userDetail.manage_product_delete == 1">
          <router-link to="/stock/manage_product/productlist" class="menu_card_content d-flex flex-column justify-center align-center">
            <div class="img_menu_content">
              <img src="@/assets/drugs.png">
            </div>
            <div class="title_menu_content">
              จัดการสินค้า
            </div>
          </router-link>
        </v-card>
        <v-card class="list_menu_content">
          <router-link to="/stock/promotion_stock/promotionexp" class="menu_card_content d-flex flex-column justify-center align-center">
            <div class="img_menu_content">
              <img src="@/assets/manage-promotion.png">
            </div>
            <div class="title_menu_content">
              จัดการสินค้าโปรโมชั่น
            </div>
          </router-link>
        </v-card>
        <v-card class="list_menu_content">
          <!-- <router-link to="/stock/history/searchproductlots" class="menu_card_content d-flex flex-column justify-center align-center"> -->
          <div @click="clear_lots_product()" style="cursor:pointer;" class="menu_card_content d-flex flex-column justify-center align-center">
            <div class="img_menu_content">
              <img src="@/assets/notifications-bell.png">
            </div>
            <div class="title_menu_content text-center">
              ตรวจสอบประวัติล็อตสินค้า
            </div>
          </div>
          <!-- </router-link> -->
        </v-card>
        <v-card class="list_menu_content">
          <router-link to="/stock/quotation/quotationmain" class="menu_card_content d-flex flex-column justify-center align-center">
            <div class="img_menu_content">
              <img src="@/assets/quotation.png">
            </div>
            <div class="title_menu_content text-center">
              ใบเสนอราคา
            </div>
          </router-link>
        </v-card>
        <v-card class="list_menu_content">
          <router-link to="/setting/productsetting" class="menu_card_content d-flex flex-column justify-center align-center">
            <div class="img_menu_content">
              <img src="@/assets/settings.png">
            </div>
            <div class="title_menu_content text-center">
              ตั้งค่าสินค้า
            </div>
          </router-link>
        </v-card>
        <v-card class="list_menu_content" v-if="$store.state.userDetail.count_warehouse !== 0 || $store.state.userDetail.count_warehouse_count !== 0 || $store.state.userDetail.count_warehouse_create !== 0">
          <router-link to="/stock/count_warehouse/countlistwarehouse" class="menu_card_content d-flex flex-column justify-center align-center">
            <div class="img_menu_content">
              <img src="@/assets/stock.png">
            </div>
            <div class="title_menu_content">
              การนับสต๊อกคลัง
            </div>
          </router-link>
        </v-card>
        <v-card class="list_menu_content" v-if="$store.state.status === 1">
          <router-link to="/stock/verifymain" class="menu_card_content d-flex flex-column justify-center align-center">
            <div class="img_menu_content">
              <img src="@/assets/stamp_verify.png">
            </div>
            <div class="title_menu_content">
              รอตรวจสอบ
            </div>
          </router-link>
        </v-card>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderStorage from "@/components/admin/stock/menustorage/HeaderStorage.vue";
export default {
  name: 'stock',
  components: {
    HeaderStorage
  },
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  data() {
    return {
      loading_page: false
    }
  },
  methods: {
    clear_lots_product(){
      this.$store.commit('temp_clear')
      this.$store.commit('temp_lots_product_clear')
      this.$router.push('/stock/history/searchproductlots')
    }
  },
  beforeMount() {
    // this.checkLogIn()
  }
}
</script>

<style scoped>
.grid_custom {
  display: grid;
  grid-template-columns: 33.33% 33.33% 33.33%;
  grid-gap: 15px 0;
}

@media only screen and (max-width: 1000px) {
  .grid_custom {
    display: grid;
    grid-template-columns: 50% 50%;
  }
}
@media only screen and (max-width: 500px) {
  .grid_custom {
    display: grid;
    grid-template-columns: 100%;
  }
}
.list_menu_content {
  width: 95%;
}

.list_menu_content:first-child {
  margin-right: 5px;
}

.list_menu_content:last-child {
  margin-left: 5px;
}
.router-link-active,
.list_menu_content:hover>.menu_card_content {
  color: #fff !important;
  background-image: linear-gradient(to right, #8cc63e, #91c657, #9cc66d);
  height: 100%;
}

.menu_card_content {
  padding: 15px;
  text-decoration: none;
  color: rgba(0, 0, 0, 0.87) !important;
  height: 100%;
}

.img_menu_content {
  width: 100px;
}

.img_menu_content>img {
  max-width: 100%;
}

.title_menu_content {
  font-size: 20px;
}
</style>
